<template>
  <div class="ima-exhibition-info">

    <ima-loading-spinner v-if="editable && exhibitions.isLoading" />

    <div v-if="!editable" class="ima-exhibition-info__name">
      <strong>Name</strong>
      {{exhibition.name}}
    </div>

    <div v-if="!exhibitions.isLoading">

      <b-field v-if="editable" label="Name">
          <b-select expanded placeholder="Auswählen" :value="exhibition.id" @input="onExhibitionChange">
          <option v-for="exhibition in exhibitions.data" :key="exhibition.id" :value="exhibition.id">{{exhibition.name}}</option>
        </b-select>
      </b-field>

      <div class="ima-exhibition-info__location">
        <strong>Ort</strong>
        {{exhibition.location || '—'}}
      </div>
      <div class="ima-exhibition-info__date">
        <strong>Datum</strong>
        <span v-if="hasDates">{{exhibition.startDate | moment('DD.MM.YYYY')}} — {{exhibition.endDate | moment('DD.MM.YYYY')}}</span>
        <span v-else>—</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { fetchExhibitions } from '@/store/modules/exhibitions'
import LoadingSpinner from '@/components/LoadingSpinner'
export default {
  name: 'ima-exhibition-info',
  props: {
    exhibition: Object,
    editable: { type: Boolean }
  },
  components: {
    'ima-loading-spinner': LoadingSpinner
  },
  data () {
    return {}
  },
  methods: {
    ...mapActions([fetchExhibitions]),
    onExhibitionChange (exhibitionId) {
      this.$emit(
        'change',
        this.exhibitions.data.find(({ id }) => id === exhibitionId)
      )
    }
  },
  created () {
    if (!this.editable) {
      return
    }
    this.fetchExhibitions()
  },
  computed: {
    ...mapState(['exhibitions']),
    hasDates () {
      return this.exhibition.startDate && this.exhibition.endDate
    }
  }
}
</script>

<style lang="scss">
.ima-exhibition-info {
  display: flex;
  flex-direction: column;

  &__icon {
    margin-right: 0.5rem;
  }

  &__name,
  &__location,
  &__date {
    display: flex;
    justify-content: space-between;
    margin: 0.5rem 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/ExhibitionInfo.vue